module.exports = __webpack_public_path__ + "static/media/08 REGGIANA CALCIO Rosta Nuova.162e0a21.svg";